export default __webpack_public_path__ + "static/media/Waving.36d548e2.gif";